import { SxProps } from "@mui/joy/styles/types";
import { TypeSX } from "app/constants/types/global.types";
import React from "react";

type Props = {exam: any};

const useStyleStudentAssignmentSubmissionPage = (
  {exam}: Props
): Record<string, SxProps> => {

  const isMarkingSchemeAvailable = exam?.status == "graded" && exam?.markingSchemeArtifactUri;

  return {
    cardDetails: {
      // display: "flex",
      // flexDirection: "row",
      display: "grid",
      gridTemplateColumns: {
        xs: "1fr",
        sm: isMarkingSchemeAvailable? "1fr 1fr 1fr":  "1fr 1fr",
      },
      gap: 2,
    },
  };
};

export default useStyleStudentAssignmentSubmissionPage;
